import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { BhApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IPhoneValidatePhoneNumber = GRpcRequestType<BhApi.PhoneBhGrpcContractClient['ValidatePhoneNumber']>;

@Injectable()
export class PhoneGrpcContractService extends GrpcCommonService<BhApi.PhoneBhGrpcContractClient> {
  constructor(protected _GrpcContract: BhApi.PhoneBhGrpcContractClient) {
    super();
  }

  validatePhoneNumber(request: IPhoneValidatePhoneNumber) {
    return from(
      this._GrpcContract.ValidatePhoneNumber(new BhApi.ValidatePhoneNumberWpcRequest(request), this.getMetadata()),
    ).pipe(grpcOperator());
  }
}
